import { Box, Stack, Text } from '@chakra-ui/react';
import type {
  RegistrationSuccessInfo,
  StatusVerificationSection,
} from '@diamond/shared/features/registration/browser';
import { buildNooRegistrationStatusSectionDetailHref } from '@diamond/sol-buyer/utils';

import { NOO_STATUS_UBUNTU_TITLE } from './NooRegistrationStatusConstants';
import { VerificationSectionCard } from './NooRegistrationStatusSectionCard';
import {
  NavigationLinksSection,
  PendingReviewBanner,
  RegistrationSuccessBanner,
  SupportSection,
} from './NooRegistrationStatusSharedUi';

interface NooRegistrationStatusMobileProps {
  isStatusVerificationView: boolean;
  displayInfo: {
    companyOrOwnerName: string | null;
    picName: string | null;
  } | null;
  submittedAtLabel: string | null;
  showSuccessBanner: boolean;
  successInfo: RegistrationSuccessInfo | null;
  verificationSections: StatusVerificationSection[];
  registrationToken: string;
}

export function NooRegistrationStatusMobile({
  isStatusVerificationView,
  displayInfo,
  submittedAtLabel,
  showSuccessBanner,
  successInfo,
  verificationSections,
  registrationToken,
}: NooRegistrationStatusMobileProps) {
  return (
    <Stack display={{ base: 'flex', lg: 'none' }} spacing={6} minW={0}>
      {isStatusVerificationView ? (
        <Stack spacing={3}>
          <Box>
            <Text sx={NOO_STATUS_UBUNTU_TITLE}>Status Verifikasi</Text>
            <Box
              as="span"
              display="inline-flex"
              mt={2}
              px={3}
              py={1}
              borderRadius="full"
              bg="#F1F8FF"
              color="#0941A8"
              fontSize="12px"
              lineHeight="16px"
              fontWeight="normal"
              data-testid="noo-buyer-status-new-badge"
            >
              Pengajuan Baru
            </Box>
            {displayInfo?.companyOrOwnerName ? (
              <Text
                mt={3}
                fontSize="24px"
                fontWeight="medium"
                lineHeight="36px"
                color="#0941A8"
              >
                {displayInfo.companyOrOwnerName}
              </Text>
            ) : null}
            {displayInfo?.picName ? (
              <Text
                mt={1}
                fontSize="16px"
                fontWeight="medium"
                lineHeight="36px"
                color="#373F41"
              >
                PIC: {displayInfo.picName}
              </Text>
            ) : null}
            {submittedAtLabel ? (
              <Text mt={3} fontSize="12px" lineHeight="15px" color="#AEAEB2">
                {submittedAtLabel}
              </Text>
            ) : null}
          </Box>

          {showSuccessBanner && successInfo ? (
            <RegistrationSuccessBanner successInfo={successInfo} />
          ) : (
            <PendingReviewBanner />
          )}
        </Stack>
      ) : (
        <Box>
          <Text sx={NOO_STATUS_UBUNTU_TITLE}>Progres Registrasi</Text>
          <Text mt={2} fontSize="sm" lineHeight="20px" color="#666666">
            Lengkapi setiap bagian di bawah untuk melanjutkan pengajuan rekanan.
          </Text>
        </Box>
      )}

      {verificationSections.length > 0 ? (
        <Stack spacing={3}>
          {verificationSections.map((section) => (
            <VerificationSectionCard
              key={section.id}
              section={section}
              registrationToken={registrationToken}
              compact
              detailHref={buildNooRegistrationStatusSectionDetailHref(section)}
            />
          ))}
        </Stack>
      ) : (
        <Text fontSize="sm" color="#637381">
          Belum ada data registrasi yang tersimpan.
        </Text>
      )}

      <SupportSection />
      <NavigationLinksSection />
    </Stack>
  );
}
